export interface IUserFeedbackAnswer {
  questionId: number;
  type: IUserFeedbackAnswerType;
  comment?: string;
}

export enum IUserFeedbackAnswerType {
  No,
  Yes,
}
